import{gql as e}from"@apollo/client";const n=e`
  mutation addFeedbackMultiResponseToMultiResponse(
    $questionAnswerId: Int!
    $responseId: Int!
    $values: [SummaryFeedbackMultiResponseAnswerInputType]!
    $contentSnippetSummaryId: Int!
  ) {
    summaryFeedback {
      addFeedbackMultiResponseToMultiResponse(
        questionAnswerId: $questionAnswerId
        contentSnippetSummaryId: $contentSnippetSummaryId
        responseId: $responseId
        values: $values
      )
    }
  }
`;export{n as CREATE_SUMMARY_FEEDBACK_MULTI_RESPONSE_TO_MULTI_RESPONSE_MUTATION};
//# sourceMappingURL=useCreateSummaryFeedbackMultiResponseToMultiResponse.graphql.js.map
